import { useState, useEffect } from "react"
import { usePathname } from "@/lib/router-helpers"
import { ChevronLeft, ChevronRight } from "lucide-react"

const banners = [
  {
    id: 1,
    image: "/images/Cheche app promo 1.svg",
    
  },
  {
    id: 2,
    image: "/images/Cheche app promo 2.svg",
    
  },
  // {
  //   id: 3,
  //   image: "/images/Cheche app promo 3.svg",
    
  // },
  // {
  //   id: 4,
  //   image: "/images/Cheche app promo 4.svg",
    
  // },
  // {
  //   id: 5,
  //   image: "/images/Cheche app promo 5.svg",
    
  // },
    {
    id: 6,
    image: "/images/Cheche app promo 6.jpg",
    
  }


]

export default function HeroBanner() {
  const [currentBanner, setCurrentBanner] = useState(0)
  const pathname = usePathname()

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  const nextBanner = () => {
    setCurrentBanner((prev) => (prev + 1) % banners.length)
  }

  const prevBanner = () => {
    setCurrentBanner((prev) => (prev - 1 + banners.length) % banners.length)
  }


  const banner = banners[currentBanner]

  if (pathname?.startsWith("/map")) {
    return null
  }

  return (
    <div className="px-4 mt-15 md:px-8 py-4 md:py-6 relative overflow-hidden group w-full">
      <div className="max-w-7xl mx-auto relative">
        <img
          src={banner.image}
          alt={`Banner ${banner.id}`}
          width={1200}
          height={120}
          className="w-full h-auto object-contain rounded-2xl"
        />
        
        <button 
          onClick={prevBanner}
          className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 bg-black/40 hover:bg-white rounded-full flex items-center justify-center shadow-md text-white/80 hover:text-pink-600 transition-all md:opacity-0 group-hover:opacity-100"
          aria-label="Previous banner"
        >
          <ChevronLeft size={20} />
        </button>

        <button 
          onClick={nextBanner}
          className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 bg-black/40 hover:bg-white rounded-full flex items-center justify-center shadow-md text-white/80 hover:text-pink-600 transition-all md:opacity-0 group-hover:opacity-100"
          aria-label="Next banner"
        >
          <ChevronRight size={20} />
        </button>
      </div>

      {/* Carousel Indicators */}
      <div className="hidden md:flex justify-center gap-2 mt-3 md:mt-4">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentBanner(index)}
            className={`w-2 h-2 rounded-full transition-all ${
              index === currentBanner ? "bg-primary w-6" : "bg-[#D9D9D9]"
            }`}
            aria-label={`Go to banner ${index + 1}`}
          />
        ))}
      </div>
    </div>
  )
}
